import { Injectable } from '@angular/core';
import { IIDolSospensioneStore } from './iidOlSospensione.store';
import { IID_OL_SOSPENSIONE } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolSospensioneQuery } from './iidOlSospensione.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.OLO_SOSPENSIONE)
export class IIDolSospensioneService extends CrudService<IID_OL_SOSPENSIONE, IIDolSospensioneStore, IIDolSospensioneQuery> {
  constructor(
    protected store: IIDolSospensioneStore,
    public query: IIDolSospensioneQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_SOSPENSIONE,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
